require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.6@core-js/library/modules/es7.symbol.observable.js
// module id = 90
// module chunks = 0